<section class="drilldown-page">
  <header class="drilldown-heading">
    <div>
      <p class="eyebrow">PURE ORIGINALS</p>
      <h1>Uploaded Pure Originals</h1>
      <p class="range">{{ rangeLabel() }}</p>
    </div>
    <a class="back-button" routerLink="/app" aria-label="Back to dashboard" title="Back to dashboard"><i class="bi bi-arrow-left" aria-hidden="true"></i></a>
  </header>

  <section class="drilldown-card" [attr.aria-busy]="loading()">
    <div class="table-toolbar">
      <div><h2>Uploaded files</h2><p>Open a Pure Original to view its details.</p></div>
      <div class="table-controls">
        <span class="count" *ngIf="page() as result">{{ result.totalElements | number }} files</span>
        <label>Rows per page <select [value]="pageSize()" (change)="changePageSize($event)" [disabled]="loading()">
          <option value="25">25</option><option value="50">50</option><option value="100">100</option>
        </select></label>
      </div>
    </div>
    <p *ngIf="loading()" class="state" role="status">Loading Pure Originals…</p>
    <p *ngIf="error()" class="state error" role="alert">Could not load uploaded Pure Originals. Please try again.</p>
    <ng-container *ngIf="page() as result">
      <div class="table-scroll" *ngIf="result.content.length; else emptyPage">
        <table class="uploaded-table">
          <colgroup>
            <col class="col-id"><col class="col-db"><col class="col-reference"><col class="col-ecu">
            <col class="col-date"><col class="col-status"><col class="col-actions">
          </colgroup>
          <thead>
            <tr><th>ID</th><th>WinOLS DB Name</th><th>WinOLS Reference</th><th>ECU Build</th><th>Date Uploaded</th><th>Status</th><th>Actions</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of result.content" (click)="openDetails(row)" (keydown.enter)="openDetails(row)" (keydown.space)="$event.preventDefault(); openDetails(row)" tabindex="0" [attr.aria-label]="'Open Pure Original ' + row.id">
              <td [title]="row.id"><span class="file-link">{{ row.id }}</span></td>
              <td [title]="row.winOlsDbName">{{ row.winOlsDbName || '—' }}</td>
              <td [title]="row.winOlsReference">{{ row.winOlsReference || '—' }}</td>
              <td [title]="row.ecuBuild">{{ row.ecuBuild || '—' }}</td>
              <td>{{ row.dateUploaded || '—' }}</td>
              <td [class.done]="row.status === 'DONE'" [class.waiting]="row.status === 'WAITING'" [class.in-progress]="row.status === 'IN_PROGRESS'" [class.error-text]="row.status === 'ERROR'">{{ row.status || '—' }}</td>
              <td><button type="button" class="details-button" (click)="$event.stopPropagation(); openDetails(row)" [attr.aria-label]="'View Pure Original ' + row.id" title="View details"><i class="bi bi-eye"></i></button></td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #emptyPage><p class="state">No Pure Originals were uploaded in this period.</p></ng-template>
      <nav class="pager" *ngIf="result.totalPages > 1" aria-label="Uploaded Pure Originals pages">
        <button type="button" class="secondary-button" (click)="goToPage(pageNumber() - 1)" [disabled]="pageNumber() === 0">Previous</button>
        <span>Page {{ pageNumber() + 1 }} of {{ result.totalPages }}</span>
        <button type="button" class="secondary-button" (click)="goToPage(pageNumber() + 1)" [disabled]="result.last">Next</button>
      </nav>
    </ng-container>
  </section>
</section>
